import { TextareaAutosize } from '@mui/material';
import React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import SwitchView from '../Uswitch/deviceview'
import TableRow from '@mui/material/TableRow';

export default function Monitor(given) {
    console.log('given' , given);
    var topicStream = given.monitorData[0];
    //var ucsinfo = given.ucs_info;   
    //var switches_info = ucsinfo.userLandscape.switches;
    //console.log('switchinfo');
    //console.log(JSON.stringify(switches_info));
    //console.log(topicStream);
    //console.log('in monitor', ucsinfo)

    return (
        <TableBody>
           
            {topicStream?.map((this_device,index) => (       
                 <TableRow>  
                    {index}
                <TableCell scope="row" align="left">{JSON.stringify(this_device)}</TableCell>       
                </TableRow>      
            ))}          
           
          
        </TableBody>
    );

}
